import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumProcessOutputTarget implements BaseEnumType {
  private static allValues: EnumProcessOutputTarget[] = []; // make sure this is top-most
  
  public static stock = new EnumProcessOutputTarget(0, "Stock", "enum_process_output_target_stock");
  public static processSameBatch = new EnumProcessOutputTarget(1, "ProcessSameBatch", "enum_process_output_target_process_same_batch");
  public static processOtherBatch = new EnumProcessOutputTarget(2, "ProcessOtherBatch", "enum_process_output_target_process_other_batch");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumProcessOutputTarget.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isStock() { return this === EnumProcessOutputTarget.stock; }
  public isProcessSameBatch() { return this === EnumProcessOutputTarget.processSameBatch; }
  public isProcessOtherBatch() { return this === EnumProcessOutputTarget.processOtherBatch; }

  public static getValues(): readonly EnumProcessOutputTarget[] {
    return EnumProcessOutputTarget.allValues;
  }

  public static getValuesExcept0(): readonly EnumProcessOutputTarget[] {
    return EnumProcessOutputTarget.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumProcessOutputTarget {
    const found = EnumProcessOutputTarget.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumProcessOutputTarget - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumProcessOutputTarget): EnumProcessOutputTarget {
    const found = name ? EnumProcessOutputTarget.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumProcessOutputTarget - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumProcessOutputTarget>): boolean {
    return this.key === other?.key;
  }
}